var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListsIconsBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.599,
    height: 31.477,
    viewBox: "0 0 36.599 31.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_172",
    x: 0,
    y: 0.004,
    width: 12.463,
    height: 15.949,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7bc5e4",
    floodOpacity: 0.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_173",
    x: 0,
    y: 7.768,
    width: 12.48,
    height: 15.95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7bc5e4",
    floodOpacity: 0.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_174",
    x: 0,
    y: 15.53,
    width: 12.475,
    height: 15.947,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7bc5e4",
    floodOpacity: 0.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_175",
    x: 5.188,
    y: 7.761,
    width: 31.411,
    height: 15.953,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7bc5e4",
    floodOpacity: 0.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_176",
    x: 5.192,
    y: 0,
    width: 29.681,
    height: 15.95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7bc5e4",
    floodOpacity: 0.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_177",
    x: 5.192,
    y: 15.518,
    width: 23.645,
    height: 15.958,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7bc5e4",
    floodOpacity: 0.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_107",
    "data-name": "Groupe 107",
    transform: "translate(-934.901 -500.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_112",
    "data-name": "Groupe 112",
    transform: "translate(634.601 -1123.618)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 300.3, 1623.99)",
    filter: "url(#Trac\\xE9_172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_172-2",
    "data-name": "Trac\\xE9 172",
    d: "M304.8,1625.612a1.906,1.906,0,0,1,.654-1.167,1.649,1.649,0,0,1,1.743-.248,1.692,1.692,0,0,1,1.051,1.417,1.739,1.739,0,0,1-3.387.682,1.48,1.48,0,0,0-.061-.145Z",
    transform: "translate(-300.3 -1624.05)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 300.3, 1623.99)",
    filter: "url(#Trac\\xE9_173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_173-2",
    "data-name": "Trac\\xE9 173",
    d: "M304.8,1740.817a1.929,1.929,0,0,1,.7-1.2,1.717,1.717,0,0,1,2.735,1.019,1.66,1.66,0,0,1-1.333,2.046,1.731,1.731,0,0,1-2.046-1.359c-.012-.06-.034-.119-.051-.178Z",
    transform: "translate(-300.3 -1731.49)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 300.3, 1623.99)",
    filter: "url(#Trac\\xE9_174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_174-2",
    "data-name": "Trac\\xE9 174",
    d: "M304.8,1856a1.862,1.862,0,0,1,.713-1.22,1.719,1.719,0,0,1,2.722,1.052,1.668,1.668,0,0,1-1.357,2.031,1.735,1.735,0,0,1-2.034-1.413.918.918,0,0,0-.043-.126Z",
    transform: "translate(-300.3 -1838.9)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 300.3, 1623.99)",
    filter: "url(#Trac\\xE9_175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_175-2",
    "data-name": "Trac\\xE9 175",
    d: "M392.977,1739.153q4.69,0,9.38,0a1.723,1.723,0,0,1,.222,3.44c-.1.01-.2.01-.3.01q-9.3,0-18.6,0a1.768,1.768,0,0,1-1.687-.9,1.717,1.717,0,0,1,1.33-2.537c.134-.013.269-.012.4-.012Z",
    transform: "translate(-372.09 -1731.39)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 300.3, 1623.99)",
    filter: "url(#Trac\\xE9_176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_176-2",
    "data-name": "Trac\\xE9 176",
    d: "M392.191,1627.436q-4.245,0-8.49,0a1.725,1.725,0,0,1-.321-3.434,3.038,3.038,0,0,1,.35-.014h16.927a1.733,1.733,0,0,1,1.793,1.221,1.708,1.708,0,0,1-1.34,2.191,3.063,3.063,0,0,1-.51.036Q396.4,1627.438,392.191,1627.436Z",
    transform: "translate(-372.15 -1623.99)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 300.3, 1623.99)",
    filter: "url(#Trac\\xE9_177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_177-2",
    "data-name": "Trac\\xE9 177",
    d: "M389.172,1854.266q2.749,0,5.5,0a1.726,1.726,0,1,1,0,3.447c-1.267.009-2.534,0-3.8,0q-3.585,0-7.17,0a1.739,1.739,0,0,1-1.768-1.187,1.7,1.7,0,0,1,1.554-2.253c.691-.027,1.383-.009,2.075-.009Z",
    transform: "translate(-372.15 -1838.74)",
    fill: "#50b2dc"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListsIconsBlue);
export default __webpack_public_path__ + "static/media/lists-icons-blue.8c85781dad9195a41391eb1c419ae44a.svg";
export { ForwardRef as ReactComponent };